import { Filter } from "@/models/Pageable"

export class FilterComment extends Filter {
  includeAudit: boolean
  onlyDemo: boolean
  targetId: string
  projectId?: string

  constructor(props) {
    super(props)

    this.includeAudit = props.includeAudit ?? false
    this.onlyDemo = props.onlyDemo ?? false
    this.targetId = props.targetId ?? ""
    this.projectId = props.projectId
  }

  getJsonObj() {
    const data = {
      includeAudit: this.includeAudit,
      ...(this.onlyDemo ? { onlyDemo: this.onlyDemo } : {}),
      targetId: this.targetId,
      projectId: this.projectId
    }

    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterComment(props)
  }

  static createDefault() {
    const props = {}

    return new FilterComment(props)
  }
}
